import { useState } from 'react';
import { Award, Globe, Trophy } from 'lucide-react';

const tabs = [
  {
    id: 'mission',
    label: 'Mission',
    content: 'Simple, innovate relentlessly and deliver cutting-edge solutions that enable businesses to thrive, adapt, and lead in an evolving business landscape.',
  },
  {
    id: 'vision',
    label: 'Vision',
    content: 'To become a global leader in technological excellence, inspiring change and enabling businesses to achieve their highest potential by Jhaishna being in the lead.',
  },
  {
    id: 'values',
    label: 'Values',
    content: 'We are driven by integrity, passion and a commitment to excellence. Our core values guide us in every decision, ensuring trust, collaboration, and impact for our clients and partners.',
  },
];

const achievements = [
  { icon: Award, title: '15+ Years Experience', subtitle: 'Delivering Industry Excellence' },
  { icon: Globe, title: 'Global Reach', subtitle: 'Strategic Partnerships & Clients' },
  { icon: Trophy, title: '2024 Fastest Growing Company Award', subtitle: 'Proven track record of cost-effective solutions' },
];

const AboutPage = () => {
  const [activeTab, setActiveTab] = useState('mission');
  const currentTab = tabs.find((t) => t.id === activeTab);

  return (
    <main>
      {/* Hero */}
      <section className="relative min-h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.pexels.com/photos/1181738/pexels-photo-1181738.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="About Us"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-navy/85" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-16 text-center w-full">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight" data-testid="about-page-title">
            Empowering Businesses With Innovative Solutions
          </h1>
          <p className="text-slate-300 text-lg">Transforming Growth Through Technology and AI</p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-xs font-mono uppercase tracking-[0.3em] text-amber mb-4">About Us</p>
            <h2 className="font-heading text-3xl font-bold text-white mb-6 tracking-tight" data-testid="about-description-title">About Us</h2>
            <p className="text-slate-400 leading-relaxed mb-6">
              Jhaishna Technologies Private Limited is a leading software development and Oracle consulting
              company based in Andhra Pradesh, India, with operations over India, Hong Kong, and the United States.
            </p>
            <p className="text-slate-400 leading-relaxed">
              Our commitment to optimizing clients' business operations efficiency has positioned us as a trusted
              partner for organizations striving to enhance their IT services and achieve sustainable business growth.
              With tailored IT advisory services and engagement models, we empower businesses to achieve their
              goals and make a positive impact, thus having us win the Fastest Growing Indian Company Leadership Award.
            </p>
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="py-16 bg-surface/30 border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-bold text-white mb-10 tracking-tight" data-testid="achievements-title">Our Achievements</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {achievements.map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.title} className="bg-surface border border-white/10 rounded-sm p-8 text-center card-hover" data-testid={`achievement-${item.title.toLowerCase().replace(/\s+/g, '-')}`}>
                  <div className="w-12 h-12 bg-amber/10 rounded-sm flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-6 h-6 text-amber" />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-white mb-2">{item.title}</h3>
                  <p className="text-sm text-slate-400">{item.subtitle}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Mission / Vision / Values */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-xl">
            <div className="flex gap-1 mb-8 border-b border-white/10">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-4 py-3 text-sm font-medium transition-colors relative ${
                    activeTab === tab.id ? 'text-amber tab-active' : 'text-slate-400 hover:text-slate-200'
                  }`}
                  data-testid={`about-${tab.id}-tab`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            {currentTab && (
              <div key={currentTab.id} className="animate-fade-in" data-testid={`about-${currentTab.id}-content`}>
                <p className="text-slate-400 leading-relaxed">{currentTab.content}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-surface/30 border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-white mb-4">Ready to build your vision into reality?</h2>
          <a href="/contact" className="btn-amber rounded-sm text-sm inline-block mt-4" data-testid="about-cta-btn">Contact Us</a>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
